import React from "react";

export default function TermsConditionsPage() {

  return <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=49a2227f-4c5b-4208-abc4-9fd48bc87c80"
                 width="100%"
                 height="12500px" />


}